// cspell:disable

import React from 'react';
import type { DocumentBlock } from '../../store/chatStore';
import { MessageFileItem } from './MessageFileItem';

interface DocumentContentProps {
  content: DocumentBlock;
}

export const DocumentContent: React.FC<DocumentContentProps> = ({
  content,
}) => {
  const documentDataUrl =
    content.source.type === 'base64'
      ? `data:${content.source.media_type};base64,${content.source.data}`
      : content.source.url;

  const handleDownload = () => {
    window.open(documentDataUrl, '_blank');
  };

  return (
    <MessageFileItem
      fileName={content?.metadata?.filename || content.name}
      mimeType={content?.metadata?.fileType || content.source.media_type}
      sizeBytes={content?.metadata?.fileSize || content.size}
      onDownload={handleDownload}
    />
  );
};

// Backwards compatibility export
export const PDFContent = DocumentContent;
